import { render, staticRenderFns } from "./SetupCompany.vue?vue&type=template&id=4affeef6&scoped=true&"
import script from "./SetupCompany.vue?vue&type=script&lang=js&"
export * from "./SetupCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4affeef6",
  null
  
)

export default component.exports